import styled from "@emotion/styled";
import { MouseEvent, useState } from "react";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

interface IOwnProps {
    delimiter: string;
    items: Array<string> | undefined;
    displayItems?: Array<string> | undefined;
    type: string;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    getItemLink: (type: string, value: string) => string;
}

const CollapsibleList = ({
    delimiter,
    items = [],
    displayItems,
    type,
    onClick,
    getItemLink,
    className,
}: IOwnProps & IWithClassName) => {
    const [isExpanded, setExpanded] = useState<boolean>(false);
    const handleExpandClick = () => setExpanded(!isExpanded);

    const renderDataBrowserLinks = (
        itemsToRender: Array<string>,
        displayItemsToRender: Array<string>,
        type: string,
    ) =>
        itemsToRender.map((item, index) => (
            <span key={item}>
                <a onClick={onClick} href={getItemLink(type, item)}>
                    {displayItemsToRender[index] || item}
                </a>
                {index !== itemsToRender.length - 1 && delimiter}
            </span>
        ));

    const displayItemsToUse = displayItems ?? items;

    return (
        <>
            {items.length > 5 ? (
                <>
                    {renderDataBrowserLinks(
                        isExpanded ? items : items.slice(0, 5),
                        isExpanded
                            ? displayItemsToUse
                            : displayItemsToUse.slice(0, 5),
                        type,
                    )}
                    <a className={className} onClick={handleExpandClick}>
                        ({isExpanded ? "Less" : "More"})...
                    </a>
                </>
            ) : (
                renderDataBrowserLinks(items, displayItemsToUse, type)
            )}
        </>
    );
};

export default styled(CollapsibleList)(({ theme }: IWithThemeProps) => ({
    color: `${theme?.palette.action.active ?? ""} !important`,
    cursor: "pointer",
    paddingLeft: 5,
}));
